import React from 'react'

import logo from '../../../../../images/logo.png'

export const FooterLogo: React.FC = () => {
    return (
        <>
            <div className="flex flex-row w-full items-center justify-end gap-2">
                <img width={40} height={40} src={logo} alt="Логотип" />
                <span className="w-full text-[#FFFFFF] uppercase leading-none font-semibold items-center justify-start text-left">
                    ТЕХНОЛОГИИ
                    <br />
                    ЗАКУПОК
                </span>
            </div>
            <p className="text-[#FFFFFF] uppercase leading-6 text-left font-bold text-[20px]">
                ДЛЯ ТЕХ КТО ЦЕНИТ <br />{' '}
                <span className="text-[#407bff]">ВРЕМЯ</span> И ХОЧЕТ <br />
                <span className="text-[#407bff]">РАБОТАТЬ</span>{' '}
                <span className="text-[#407bff]">ЭФФЕКТИВНО</span>
            </p>
        </>
    )
}
